<template>
  <div>
    <!-- <section class="inner_banner"></section> -->

    <section class="exchange_wrapp">
      <div class="container" id="switch-layer">
        <ul class="nav nav-pills" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" data-toggle="pill" href="#liquidity"  @click="setIsLiquidityEnabled(false)"
              >Liquidity</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="pill" href="#provider"  @click="setIsLiquidityEnabled(true)">Provider</a>
          </li>
        </ul>
      </div>
      <div class="container" v-if="!enabled">
        <article class="row justify-content-center">
          <aside class="col-md-12">
            <div class="banner_right_box banner_right_box_inner">
              <div class="row">
                <div class="col-md-12 padding-top-15">
                  <h3 style="text-align: center">Add Liquidity</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 padding-top-15">
                  <div class="banner_right_box banner_right_box_inner">
                    <h4>A 1</h4>
                    <div class="quantity">
                      <div class="form-group">
                        <label for="quantity">Token:</label>
                        <v-select
                          :options="options"
                          :searchable="false"
                          :clearable="false"
                          :value="selectedOptionTokenA"
                          :disabled="
                            isTransactionInProgress ||
                            isTokenAApproved ||
                            isTokenBApproved
                          "
                          @input="(option) => selectTokenA(option)"
                          label="title"
                        >
                          <template slot="option" slot-scope="option">
                            <img
                              class="combo-img"
                              :src="'../images/' + option.image"
                            />{{ option.title }}
                          </template>

                          <template
                            slot="selected-option"
                            slot-scope="option"
                            :value="option.level"
                          >
                            <img
                              class="combo-img"
                              :src="'../images/' + option.image"
                            />{{ option.title }}
                          </template>
                        </v-select>
                      </div>
                      <div class="form-group">
                        <label for="quantity">Amount:</label>
                        <input
                          type="number"
                          class="form-control"
                          :disabled="
                            isTransactionInProgress ||
                            isTokenAApproved ||
                            isTokenBApproved
                          "
                          v-model="amount"
                          @input="resetTokenApprove"
                          @change="resetTokenApprove"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 padding-top-15">
                  <div class="banner_right_box banner_right_box_inner">
                    <h4>B 1</h4>
                    <div class="quantity">
                      <div class="form-group">
                        <label for="quantity">Token:</label>
                        <v-select
                          :options="options"
                          :searchable="false"
                          :clearable="false"
                          :value="selectedOptionTokenB"
                          :disabled="
                            isTransactionInProgress ||
                            isTokenAApproved ||
                            isTokenBApproved
                          "
                          @input="(option) => selectTokenB(option)"
                          label="title"
                        >
                          <template slot="option" slot-scope="option">
                            <img
                              class="combo-img"
                              :src="'../images/' + option.image"
                            />{{ option.title }}
                          </template>

                          <template
                            slot="selected-option"
                            slot-scope="option"
                            :value="option.level"
                          >
                            <img
                              class="combo-img"
                              :src="'../images/' + option.image"
                            />{{ option.title }}
                          </template>
                        </v-select>
                      </div>
                      <div class="form-group">
                        <label for="quantity">Amount:</label>
                        <input
                          type="number"
                          class="form-control"
                          :disabled="
                            isTransactionInProgress ||
                            isTokenAApproved ||
                            isTokenBApproved
                          "
                          v-model="amount"
                          @input="resetTokenApprove"
                          @change="resetTokenApprove"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <div class="row">
                <div class="col-md-12 text-center">
                  <b-button
                    size="lg"
                    class="btn_blue"
                    style="width: 200px; margin: 15px"
                    :disabled="
                      isTransactionInProgress ||
                      isTokenAApproved ||
                      (!amount ? true : false) ||
                      (selectedOptionTokenA ? false : true)
                    "
                    @click="approveTokenA"
                  >
                    Approve
                    {{
                      selectedOptionTokenA ? selectedOptionTokenA.title : "A 1"
                    }}
                  </b-button>
                  <b-button
                    size="lg"
                    class="btn_blue"
                    style="width: 200px; margin: 15px"
                    :disabled="
                      isTransactionInProgress ||
                      isTokenBApproved ||
                      (!amount ? true : false) ||
                      (selectedOptionTokenB ? false : true)
                    "
                    @click="approveTokenB"
                  >
                    Approve
                    {{
                      selectedOptionTokenB ? selectedOptionTokenB.title : "B 1"
                    }}
                  </b-button>
                  <b-button
                    size="lg"
                    class="btn_blue"
                    style="width: 200px; margin: 15px"
                    :disabled="
                      isTransactionInProgress ||
                      !isTokenAApproved ||
                      !isTokenBApproved ||
                      (!amount ? true : false) ||
                      (selectedOptionTokenA ? false : true) ||
                      (selectedOptionTokenB ? false : true)
                    "
                    @click="addLiquidity"
                  >
                    Transfer
                  </b-button>
                </div>
              </div>
            </div>
            <br />

            <div class="banner_right_box">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12 padding-top-15">
                      <div
                        class="banner_right_box banner_right_box_simple"
                        style="text-align: center"
                      >
                        <h6>User pool share</h6>
                        <h6 class="text-muted">
                          {{ userPoolShare | formatNum }}
                        </h6>
                      </div>
                    </div>

                    <div class="col-md-12 padding-top-15">
                      <div
                        class="banner_right_box banner_right_box_simple"
                        style="text-align: center"
                      >
                        <h6>Fees 24 hrs</h6>
                        <h6 class="text-muted">{{ feesPrice | formatNum }}</h6>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 padding-top-15" v-if="balance">
                  <div class="banner_right_box banner_right_box_inner">
                    <h4>Withdraw</h4>
                    <div class="quantity">
                      <div class="my-2" v-if="balance">
                        Your receipt token balance is
                        <span class="badge badge-info float-right">{{
                          balance | toEth | dollars
                        }}</span>
                      </div>
                      <div class="my-2" v-if="withdrawableFunds">
                        Your withdrawal fees earned balance is
                        <span class="badge badge-success float-right">{{
                          withdrawableFunds | toEth | dollars
                        }}</span>

                        <hr />

                        <div class="row">
                          <div class="col-md-12 text-center">
                            <b-button
                              variant="success"
                              size="lg"
                              @click="withdrawFees"
                            >
                              Withdraw all fees
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </article>
      </div>
      <div class="container" v-if="enabled">
        <article class="row justify-content-center">
          <aside class="col-md-12">
            <div class="banner_right_box">
              <div class="row">
                <div class="col-md-6 padding-top-15">
                  <div class="banner_right_box banner_right_box_inner">
                    <h4>Add Provider</h4>
                    <div class="quantity">
                      <div class="form-group">
                        <label for="quantity">Address:</label>
                        <input
                          type="text"
                          class="form-control"
                          :disable="isAddProvTransactionInProgress"
                          v-model="addProvAddress"
                          @input="addProvAddressChange"
                          @change="addProvAddressChange"
                        />
                      </div>
                      <div
                        class="form-group"
                        style="text-align: -webkit-center"
                      >
                        <b-button
                          size="lg"
                          class="btn_blue"
                          style="width: 200px; margin: 15px"
                          :disabled="
                            !addProvAddress || isAddProvTransactionInProgress
                          "
                          @click="addProvider"
                        >
                          Add
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 padding-top-15">
                  <div class="banner_right_box banner_right_box_inner">
                    <h4>Remove Provider</h4>
                    <div class="quantity">
                      <div class="form-group">
                        <label for="quantity">Address:</label>
                        <input
                          type="text"
                          class="form-control"
                          :disable="isRemoveProvTransactionInProgress"
                          v-model="removeProvAddress"
                          @input="removeProvAddressChange"
                          @change="removeProvAddressChange"
                        />
                      </div>

                      <div
                        class="form-group"
                        style="text-align: -webkit-center"
                      >
                        <b-button
                          size="lg"
                          class="btn_blue"
                          style="width: 200px; margin: 15px"
                          :disabled="
                            !removeProvAddress ||
                            isRemoveProvTransactionInProgress
                          "
                          @click="removeProvider"
                        >
                          Remove
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-12 padding-top-15">
                  <div class="banner_right_box banner_right_box_inner">
                    <h4>Liquidity Providers</h4>
                    <b-table striped hover :items="providers"></b-table>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ethers } from "ethers";
import { gql } from "apollo-boost";
import vSelect from "vue-select";

export default {
  name: "Liquidity",
  components: {
    vSelect,
  },
  computed: {
    ...mapGetters(["contracts", "erc20TokenContract", "account", "feesPrice"]),
    providers() {
      const data = this.liquidityProviders || [];
      return data.map((provider) => ({ Address: provider.id }));
    },
  },
  data() {
    return {
      options: [],
      selectedOptionTokenA: null,
      selectedOptionTokenB: null,
      isTokenAApproved: false,
      isTokenBApproved: false,
      amount: "",
      enabled: false,
      balance: "",
      withdrawableFunds: "",
      isTransactionInProgress: false,
      pollBalance: null,
      pollWithdrawableFunds: null,
      addProvAddress: "",
      removeProvAddress: "",
      isAddAddressValid: false,
      isRemoveAddressValid: false,
      isAddProvTransactionInProgress: false,
      isRemoveProvTransactionInProgress: false,
      userPoolShareTimmer: null,
      userPoolShare: "-",
    };
  },
  apollo: {
    liquidityProviders: {
      query: gql`
        query {
          liquidityProviders {
            id
          }
        }
      `,
      pollInterval: 2000,
    },
    liquidityPair: {
      query: gql(`query {
                liquidityPair(id: "${"0x60Daf89be825A35C58ACE1f17aAACDeb5b0B08D2".toLowerCase()}") {
                    pairName
                    tokenALiquidity
                    tokenARatio
                    tokenBLiquidity
                    tokenBRatio
                    totalLiquidity
                    tokenA
                    tokenAName
                    tokenASymbol
                    tokenB
                    tokenBName
                    tokenBSymbol
                    minimumDeposit
                    maximumDeposit
                }
            }`),
      pollInterval: 2000,
      result({ data }) {
        const { liquidityPair } = data;

        this.options = [];
        this.options.push({
          id: 1,
          name: liquidityPair.tokenASymbol,
          title: liquidityPair.tokenASymbol,
          address: liquidityPair.tokenA,
          liquidity: liquidityPair.tokenALiquidity,
          ratio: liquidityPair.tokenARatio,
          image:
            liquidityPair.tokenASymbol == "USDC" ? "icon1.png" : "icon2.png",
        });

        this.options.push({
          id: 2,
          name: liquidityPair.tokenBSymbol,
          title: liquidityPair.tokenBSymbol,
          address: liquidityPair.tokenB,
          liquidity: liquidityPair.tokenBLiquidity,
          ratio: liquidityPair.tokenBRatio,
          image:
            liquidityPair.tokenBSymbol == "USDC" ? "icon1.png" : "icon2.png",
        });
        // console.log("===>", JSON.stringify(this.tokenList));
      },
    },
  },
  methods: {
    async setIsLiquidityEnabled(isEnabled) {
      this.enabled = isEnabled;
    },
    showUnConnected() {
      this.$toastr.Add({
        name: "err1",
        title: "Not Connected",
        msg: "Please connect with wallet",
        clickClose: false,
        timeout: 5000,
        type: "error",
        preventDuplicates: true,
        style: { backgroundColor: "red", opacity: "1" },
      });
    },
    showErrorMessage(title, msg) {
      this.$toastr.Add({
        name: "err2",
        title: title,
        msg: msg,
        clickClose: false,
        timeout: 5000,
        type: "error",
        preventDuplicates: true,
        style: { backgroundColor: "red", opacity: "1" },
      });
    },
    showSuccessMessage() {
      this.$toastr.Add({
        name: "success1",
        title: "Success",
        msg: "Transaction successfully done.",
        clickClose: false,
        timeout: 5000,
        type: "success",
        preventDuplicates: true,
        style: { backgroundColor: "#279930", opacity: "1" },
      });
    },
    selectTokenA(option) {
      this.selectedOptionTokenA = option;
      if (this.options[0].id == option.id) {
        this.selectedOptionTokenB = this.options[1];
      } else {
        this.selectedOptionTokenB = this.options[0];
      }
      console.log(this.selectedOptionTokenA);
      console.log(this.selectedOptionTokenB);
      this.checkAllowance();
    },
    selectTokenB(option) {
      this.selectedOptionTokenB = option;
      if (this.options[0].id == option.id) {
        this.selectedOptionTokenA = this.options[1];
      } else {
        this.selectedOptionTokenA = this.options[0];
      }
      this.checkAllowance();
    },
    addProvAddressChange() {
      try {
        ethers.utils.getAddress(this.addProvAddress);
        this.isAddAddressValid = true;
      } catch (e) {
        this.isAddAddressValid = false;
        return;
      }
    },
    removeProvAddressChange() {
      try {
        ethers.utils.getAddress(this.removeProvAddress);
        this.isRemoveAddressValid = true;
      } catch (e) {
        this.isRemoveAddressValid = false;
        return;
      }
    },
    async addProvider() {
      try {
        if (!this.contracts) {
          this.showUnConnected();
          return;
        }
        this.isAddProvTransactionInProgress = true;

        const { accessControlsContract } = this.contracts;
        try {
          const tx = await accessControlsContract.addLiquidityProviderRole(
            this.addProvAddress
          );
          await tx.wait(1);
        } catch (e) {
          this.isAddProvTransactionInProgress = false;
        }

        this.isAddProvTransactionInProgress = false;
        this.addProvAddress = "";
      } catch (e) {
        this.showErrorMessage("Opps!", "Something went wrong..");
      }
    },
    async removeProvider() {
      try {
        if (!this.contracts) {
          this.showUnConnected();
          return;
        }
        this.isRemoveProvTransactionInProgress = true;

        const { accessControlsContract } = this.contracts;
        try {
          const tx = await accessControlsContract.removeLiquidityProviderRole(
            this.removeProvAddress
          );
          await tx.wait(1);
        } catch (e) {
          this.isRemoveProvTransactionInProgress = false;
        }

        this.isRemoveProvTransactionInProgress = false;
        this.removeProvAddress = "";
      } catch (e) {
        this.showErrorMessage("Opps!", "Something went wrong..");
      }
    },
    resetTokenApprove() {
      this.isTokenAApproved = false;
      this.isTokenBApproved = false;
      this.checkAllowance();
    },
    async addLiquidity() {
      if (!this.contracts) {
        this.showUnConnected();
        return;
      }
      this.isTransactionInProgress = true;
      const { liquidityPairContract } = this.contracts;

      try {
        let isValidAllownce = await this.checkAllowance();
        if (isValidAllownce) {
          const addAmount = ethers.utils.parseUnits(this.amount, 6);
          // add the liquidity
          const tx = await liquidityPairContract.addLiquidity(addAmount, {
            gasLimit: 300000,
          });
          await tx.wait(1);
          this.amount = "";
          this.isTokenAApproved = false;
          this.isTokenBApproved = false;
          this.isTransactionInProgress = false;
        } else {
          this.isTransactionInProgress = false;
        }
      } catch (e) {
        this.isTransactionInProgress = false;
        this.showErrorMessage("Opps!", "Something went wrong..");
      }
    },

    async approveTokenA() {
      if (!this.contracts) {
        this.showUnConnected();
        return;
      }
      const { liquidityPairContract } = this.contracts;

      try {
        if (this.isTokenAApproved) {
          return;
        }

        this.isTransactionInProgress = true;
        const addAmount = ethers.utils.parseUnits(this.amount, 6);

        const tokenAContract = this.erc20TokenContract(
          this.selectedOptionTokenA.address
        );

        await tokenAContract.approve(liquidityPairContract.address, addAmount);
        this.isTokenAApproved = true;
      } catch (e) {
        this.isTransactionInProgress = false;
        this.isTokenAApproved = false;
        this.showErrorMessage("Opps!", "Something went wrong..");
      }

      this.isTransactionInProgress = false;
    },
    async approveTokenB() {
      if (!this.contracts) {
        this.showUnConnected();
        return;
      }
      const { liquidityPairContract } = this.contracts;

      try {
        if (this.isTokenBApproved) {
          return;
        }

        this.isTransactionInProgress = true;
        const addAmount = ethers.utils.parseUnits(this.amount, 6);

        const tokenBContract = this.erc20TokenContract(
          this.selectedOptionTokenB.address
        );
        await tokenBContract.approve(liquidityPairContract.address, addAmount);
        this.isTokenBApproved = true;
      } catch (e) {
        this.isTransactionInProgress = false;
        this.isTokenBApproved = false;
        this.showErrorMessage("Opps!", "Something went wrong..");
      }

      this.isTransactionInProgress = false;
    },
    async checkAllowance() {
      if (!this.contracts) {
        this.showUnConnected();
        return null;
      }
      const { liquidityPairContract } = this.contracts;
      try {
        if (
          !this.selectedOptionTokenA.address ||
          !this.selectedOptionTokenB.address
        ) {
          return null;
        }
        if (!this.amount || (this.amount && Number(this.amount) <= 0)) {
          return null;
        }
        const addAmount = ethers.utils.parseUnits(this.amount, 6);

        this.isTransactionInProgress = true;

        const tokenAContract = this.erc20TokenContract(
          this.selectedOptionTokenA.address
        );

        let allowanceA = await tokenAContract.allowance(
          this.account,
          liquidityPairContract.address
        );

        if (Number(addAmount._hex) <= Number(allowanceA._hex)) {
          this.isTokenAApproved = true;
        }

        const tokenBContract = this.erc20TokenContract(
          this.selectedOptionTokenB.address
        );

        let allowanceB = await tokenBContract.allowance(
          this.account,
          liquidityPairContract.address
        );

        if (Number(addAmount._hex) <= Number(allowanceB._hex)) {
          this.isTokenBApproved = true;
        }

        this.isTransactionInProgress = false;
        return this.isTokenAApproved && this.isTokenBApproved ? true : false;
      } catch (e) {
        console.error(e);
        this.isTransactionInProgress = false;
        this.isTokenAApproved = false;
        this.isTokenBApproved = false;
        this.showErrorMessage("Opps!", "Something went wrong..");
        return null;
      }
    },
    async withdrawFees() {
      if (!this.contracts) {
        this.showUnConnected();
        return;
      }
      const { liquidityReceiptContract } = this.contracts;

      try {
        const tx = await liquidityReceiptContract.withdrawFunds({
          gasLimit: 5000000,
        });
        await tx.wait(1);
      } catch (e) {
        console.error(e);
      }
    },
    async getBalance() {
      this.pollBalance = setInterval(async () => {
        if (this.account) {
          const { liquidityReceiptContract } = this.contracts;
          this.balance = await liquidityReceiptContract.balanceOf(this.account);
        }
      }, 1100);
    },
    async getWithdrawableFunds() {
      this.pollWithdrawableFunds = setInterval(async () => {
        if (this.account) {
          const { liquidityReceiptContract } = this.contracts;
          this.withdrawableFunds =
            await liquidityReceiptContract.withdrawableFundsOf(this.account);
        }
      }, 1100);
    },
    async getUserPoolShare() {
      this.userPoolShareTimmer = setInterval(async () => {
        if (this.account) {
          try {
            const { liquidityReceiptContract } = this.contracts;
            let balanceOf = await liquidityReceiptContract.balanceOf(
              this.account
            );
            let totalSupply = await liquidityReceiptContract.totalSupply();
            this.userPoolShare = (
              (Number(balanceOf) / Number(totalSupply)) *
              100
            ).toFixed(6);
          } catch (e) {
            console.error(e);
          }
        }
      }, 5000);
    },
    async startTimer() {
      await this.$store.dispatch("loadData");
      setInterval(async () => {
        await this.$store.dispatch("loadData");
      }, 10000);
    },
  },
  async mounted() {
    this.getBalance();
    this.getWithdrawableFunds();
    this.getUserPoolShare();
    this.startTimer();
  },
  beforeDestroy() {
    clearInterval(this.pollBalance);
    clearInterval(this.pollWithdrawableFunds);
    clearInterval(this.userPoolShareTimmer);
  },
};
</script>

<style scoped>
</style>
